// Display only: the server enforces the cooldown across sessions/account IDs.
export const replacementAvailableAt = (account) => {
  const explicit = Date.parse(account?.replacement_available_at || '');
  if (Number.isFinite(explicit)) return explicit;
  const replaced = Date.parse(account?.replaced_at || '');
  return Number.isFinite(replaced) ? replaced + 7 * 24 * 60 * 60 * 1000 : 0;
};
